import { IS_DAY } from "../lib/theme";
import React, { useEffect, useRef } from "react";

const WAVES = [
  { amp: 42, freq: 0.0035, speed: 0.012, y: 0.32, color: IS_DAY ? "rgba(59,130,246," : "rgba(168,85,247," },
  { amp: 58, freq: 0.0026, speed: 0.009, y: 0.5, color: "rgba(56,189,248," },
  { amp: 36, freq: 0.0042, speed: 0.015, y: 0.68, color: "rgba(229,197,111," },
  { amp: 66, freq: 0.0021, speed: 0.007, y: 0.55, color: IS_DAY ? "rgba(29,78,216," : "rgba(139,92,246," },
];

const FlowingWaves = ({ intensity = 1 }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    const parent = canvas.parentElement;
    let w, h, raf, t = 0, last = 0, scrollIdleAt = 0;

    const resize = () => {
      w = parent.offsetWidth;
      h = parent.offsetHeight;
      canvas.width = w;
      canvas.height = h;
    };
    resize();
    window.addEventListener("resize", resize);
    const onScroll = () => {
      scrollIdleAt = performance.now() + 150;
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    const draw = (ts) => {
      if (ts < scrollIdleAt) {
        setTimeout(() => { raf = requestAnimationFrame(draw); }, 150);
        return;
      }
      raf = requestAnimationFrame(draw);
      if (ts - last < 33) return;
      last = ts;
      t += 1;
      ctx.clearRect(0, 0, w, h);
      for (const wv of WAVES) {
        for (let s = 0; s < 3; s++) {
          ctx.beginPath();
          ctx.strokeStyle = wv.color + Math.min((0.16 - s * 0.05) * intensity, 0.5).toFixed(3) + ")";
          ctx.lineWidth = 1.2;
          for (let x = 0; x <= w; x += 8) {
            const y =
              h * wv.y +
              Math.sin(x * wv.freq + t * wv.speed + s * 0.8) * wv.amp +
              Math.sin(x * wv.freq * 2.3 + t * wv.speed * 1.7) * wv.amp * 0.3;
            if (x === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
          }
          ctx.stroke();
        }
      }
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("scroll", onScroll);
    };
  }, [intensity]);

  return <canvas ref={ref} className="absolute inset-0 w-full h-full pointer-events-none" aria-hidden="true" data-testid="flowing-waves" />;
};

export default FlowingWaves;
